import * as React from "react";
import {RouteComponentProps, Redirect} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {handleNavigation, indexPath, routePaths} from "egold/routes";
import Timer from "egold/components/timer";
import {IEgoldUserDetails, ISellPrice, IVerifySellPrice} from "StateInterface";
import {useEffect, useRef, useState} from "react";
import {insideHeader, renderProceed, ToastBgColor} from "egold/utils";
import {showToast, verifySellPrice} from "egold/actions";
import {vendor} from "egold/egold-config";
import {notifyAndroid} from "utils/android";

interface IConnectProps {
    sellPrice: ISellPrice;
    eGoldUserDetails: IEgoldUserDetails;
    verifySellPrice: IVerifySellPrice;
    isError: boolean;
    isAndroid: boolean;
}

function SellGoldConfirm(props: IConnectProps & RouteComponentProps) {
    const [redirectRequired , updateRedirectRequired] = useState<boolean>(false);
    const [timerRestarted , updateTimerRestarted] = useState<boolean>(false);
    const timerRef: any = useRef();
    useEffect(() => {
        if (props.isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: false});
        }
        if (props.location.state) {
          const verifySellInfo = {
              user_info : {
                  vendor_id: String(props.eGoldUserDetails.vendor_id),
                  user_id: props.eGoldUserDetails.user_id,
              },
              gold_info: {
                  rate_id: props.sellPrice.rate_id,
                  gold_amount: Number(props.location.state.userInput.inGrams),
                  sell_price: Number(props.location.state.userInput.inRupees),
              },
          };
          props.dispatch(verifySellPrice(vendor.SAFEGOLD, verifySellInfo));
        } else {
          props.dispatch(showToast(ToastBgColor.WARNING, "Transaction Cancelled"));
          updateRedirectRequired(true);
        }
    }, [timerRestarted]);
    const handleProceed = () => {
        if (props.eGoldUserDetails.bankAccountDetails.isPanVerified
            && props.eGoldUserDetails.bankAccountDetails.panNameMatch
            && props.eGoldUserDetails.bankAccountDetails.bankAccount
            && Object.entries(props.eGoldUserDetails.bankAccountDetails.bankAccount).length > 0) {
            handleNavigation(routePaths.VERIFIED_BANK_ACCOUNT);
        }
        else {
            props.history.push({
                pathname: `${indexPath}${routePaths.BANK_DETAILS}`,
                state: {amountEnteredInRupees: props.location.state.userInput.inRupees},
            });
        }
    };
    function restartTimer(time) {
        updateTimerRestarted(true);
        timerRef.current.reStartTimer(time);
    }
    if (redirectRequired || props.isError) {
        return <Redirect to={`${indexPath}${routePaths.SELL_GOLD}`}/>;
    }
    return (
        props.verifySellPrice &&
        <div className="confirm-container mx-2">
            {insideHeader("Confirm Sell", props.history.goBack)}
            <div className="text-center">
                <span className="d-block mt-1 small-text">
                    Gold rate valid for&nbsp;
                     <Timer seconds={300}
                            ref={timerRef}
                            handleTimeEnd={() => restartTimer(300)}
                     />
                </span>
            </div>
            <div className="mt-4 mb-2 pl-1" style={{fontSize: "13px"}}>
                Live Sell Price <b>Rs. {props.sellPrice.current_price}/g</b>
            </div>
            {renderDetails(props.verifySellPrice)}
            {renderProceed("Sell", handleProceed)}
        </div>
    );
}

function renderDetails(sellDetails: IVerifySellPrice) {
    return(
        <div className="table-border p-2 mt-2">
            <table className="table table-borderless table-sm" style={{fontSize: "14px"}}>
                <tbody>
                <tr>
                    <td>Gold Rate</td>
                    <td className="text-right">
                        <i className="fa fa-inr price-icon-small" aria-hidden="true"/>&nbsp;
                        {sellDetails.sell_price}
                    </td>
                </tr>
                <tr>
                    <td>Quantity</td>
                    <td className="text-right">{sellDetails.gold_amount}(gm)</td>
                </tr>
                <tr>
                    <td>Purity</td>
                    <td className="text-right">99.5%</td>
                </tr>
                <tr>
                    <td>Date</td>
                    <td className="text-right">{new Date().toDateString()}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        sellPrice: state.eGold.sellPrice,
        verifySellPrice: state.eGold.verifySellPrice,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        isError: state.eGold.isError,
        isAndroid: state.login.isAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(SellGoldConfirm);
